import { AppState, ImageAssetAttribute, UploadFileForAssetAction, VideoAssetAttribute } from "@store";
import * as cn from "classnames";
import { FieldInfo } from "rd-redux-forms";
import * as React from "react";
import { connectAdvanced, Dispatch } from "react-redux";
import { AssetAttributeFormMeta } from "../../../store/adunit-builder/adUnitAssetBuilderForm";
import "./FileUploader.css";
import "./MultipleFileUploader.css";
import { LoadingSpinner } from "../../LoadingSpinner";
import { parseUrlForFileName } from "@common";

let inputCounter = 1;

interface MultipleFileUploaderComponentProps {
    value: string;
    fileTypes?: string[];
    uploadingInputId: string;
    onUrlChanged: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onFileSelected?: (e: React.ChangeEvent<HTMLInputElement>, inputId: string) => void;
}

class MultipleFileUploaderComponent extends React.Component<MultipleFileUploaderComponentProps> {
    private inputId = `MultipleFileUploader${++inputCounter}`;

    render() {
        const { value, uploadingInputId, fileTypes, onUrlChanged, onFileSelected } = this.props;
        const accept = fileTypes && fileTypes.length ? fileTypes.join(",") : undefined;
        const isUploading = uploadingInputId === this.inputId;

        return (
            <div className="FileUploader">
                <textarea
                    value={parseUrlForFileName(value) || ""}
                    className={cn("FileUploader__url multiple-file-textarea important", value ? "has-files" : "")}
                    onChange={onUrlChanged}
                    rows={4}
                    disabled={true}
                />
                <label className={cn("FileUploader__file-selector", { uploading: isUploading })}>
                    <input
                        className="FileUploader__file-input"
                        accept={accept}
                        type="file"
                        onChange={e => onFileSelected(e, this.inputId)}
                        disabled={!!uploadingInputId}
                    />
                    <span className="FileUploader__file-selector-label multiple-file-btn important">Add file</span>
                </label>
                <span className={cn("FileUploader__loader-indicator", { uploading: isUploading })}>
                    <LoadingSpinner />
                </span>
            </div>
        );
    }
}

export interface MultipleFileUploaderProps {
    asset: ImageAssetAttribute | VideoAssetAttribute;
    meta: AssetAttributeFormMeta;
    fieldName: string;
    field: FieldInfo;
    fieldEvents: any;
}

const assetTypeMimePrefix = {
    image: "image/",
    video: "video/"
};

export const MultipleFileUploader = connectAdvanced((dispatch: Dispatch) => {
    return (appState: AppState, ownProps: MultipleFileUploaderProps): MultipleFileUploaderComponentProps => {
        const { asset, field, fieldEvents, fieldName, meta } = ownProps;
        const fieldValue: string[] = field.value || [];
        const value = fieldValue.join("\n");

        return {
            value,
            fileTypes: asset.formats
                ? asset.formats
                      .map(f => {
                          const mimeTypePrefix = assetTypeMimePrefix[asset.type];

                          if (!mimeTypePrefix) {
                              return undefined;
                          }

                          return `${mimeTypePrefix}${f.toLowerCase()}`;
                      })
                      .filter(f => !!f)
                : undefined,
            onUrlChanged: e => {
                const urls = e.currentTarget.value.split("\n");
                fieldEvents.onChange(urls);
            },
            uploadingInputId: appState.adUnitBuilder.uploadingFileId,
            onFileSelected(e: React.ChangeEvent<HTMLInputElement>, inputId: string) {
                if (e.currentTarget.files && e.currentTarget.files.length) {
                    dispatch(
                        UploadFileForAssetAction({
                            file: e.currentTarget.files[0],
                            fieldName,
                            meta,
                            currentValue: fieldValue,
                            uploadingFileId: inputId
                        })
                    );
                }
            }
        };
    };
})(MultipleFileUploaderComponent);
